import React from 'react';
import InputFields from './components/InputFields';
import ModalWindows from './components/ModalWindows/ModalWindows';
import classNames from 'classnames';
import style from './WatchesForm.module.scss';

interface IWatchesForm {
	isVisible: boolean;
}

const WatchesForm: React.FC<IWatchesForm> = ({ isVisible }) => {
	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	return (
		<div className={containerClasses} data-test="WatchesForm">
			<InputFields />
			<ModalWindows />
		</div>
	);
};

export default React.memo(WatchesForm);
